<div class="tolt-affiliate-window fx-cover fx-center-all" (click)="close()" #container>
    <div class="tolt-affiliate-window-inner" #window>
        <button class="tolt-affiliate-window-close-button btn-small nu-btn-icon" (click)="close()">
            <svg class="nu-icon nu-icon-small nu-ic-close">
                <use xlink:href="./assets/icons/symbol-defs.svg#nu-ic-close"></use>
            </svg>
        </button>
        <!-- Allow clipboard write so that user can copy invite links -->
        <iframe #iframe [src]="iFrameUrl | safe" allow="clipboard-write" class="tolt-affiliate-window-iframe"></iframe>
    </div>
</div>
